// data/products.js
const products = [
  {
    id: 1,
    name: "Kanchipuram Silk Saree",
    price: 6999,
    category: "Sarees",
    image: "https://picsum.photos/seed/kanchipuram/600/800",
    tags: ["Silk", "Traditional", "Wedding"],
  },
  {
    id: 2,
    name: "Banarasi Brocade Saree",
    price: 5499,
    category: "Sarees",
    image: "https://picsum.photos/seed/banarasi/600/800",
    tags: ["Brocade", "Festive"],
  },
  {
    id: 3,
    name: "Georgette Party Gown",
    price: 3299,
    category: "Gowns",
    image: "https://picsum.photos/seed/gown/600/800",
    tags: ["Party", "Trendy"],
  },
  {
    id: 4,
    name: "Cotton Kurti Set",
    price: 1799,
    category: "Kurtis",
    image: "https://picsum.photos/seed/kurti/600/800",
    tags: ["Casual", "Comfort"],
  },
  {
    id: 5,
    name: "Organza Designer Saree",
    price: 4599,
    category: "Sarees",
    image: "https://picsum.photos/seed/organza/600/800",
    tags: ["Designer", "Lightweight"],
  },
  {
    id: 6,
    name: "Anarkali Suit",
    price: 3899,
    category: "Suits",
    image: "https://picsum.photos/seed/anarkali/600/800",
    tags: ["Festive", "Elegant"],
  },
];

export default products;
